import React from 'react'
// import { Text } from 'styles/reactnative'
import { StyledButton } from './styles'
import { useHistory } from 'react-router-dom'

interface IProps {
	title?: string
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
	navurl?: string
	style?: any
	border?: { width: string; color?: string; style?: string }
	backgroundHover?: any
	textHover?: any
	icon?: any
	iconLeft?: boolean
	size?: number
	textStyle?: React.CSSProperties
}
const CButton = ({
	title,
	icon,
	onClick,
	style,
	border,
	backgroundHover,
	textHover,
	iconLeft,
	size,
	textStyle,
	navurl,
}: IProps) => {
	const nav = useHistory()
	return (
		<StyledButton
			size={size}
			className={'customBtn'}
			type="button"
			backgroundHover={backgroundHover}
			textHover={textHover}
			style={{
				borderStyle:
					border?.style !== undefined ? border.style : 'solid',
				borderWidth: border?.width !== undefined ? border.width : 0,
				borderColor:
					border?.color !== undefined ? border.color : 'transparent',
				display: 'flex',
				flexDirection: icon ? 'row' : 'column',
				alignItems: 'center',
				alignSelf: 'center',
				justifyContent: 'center',
				...style,
			}}
			onClick={e => {
				if (onClick) onClick(e)
				if (navurl) {
					nav.push(navurl)
				}
			}}>
			{iconLeft && icon ? icon : null}
			{/* <Text style={{ ...textStyle }}></Text> */}
			{title}
			{!iconLeft && icon ? icon : null}
		</StyledButton>
	)
}

export default React.memo(CButton)
